import interceptedAxios from '../../../utils/interceptedAxios'
import { handleFileName } from './handleName/handleFileName'

export async function exportProvisioningHistory (
  tenantId: string,
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string) => any
): Promise<void> {
  const url = `/fileprocessingservice/api/v1/udp/provisioningHistory/download?tenantId=${tenantId}`
  interceptedAxios
    .get(url, { responseType: 'blob', timeout: 10000 })
    .then((response) => {
      handleFileName(response)
      onSuccess(response)
    })
    .catch((error) => {
      onFailure(error)
    })
}
